import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { featureFlags } from 'src/config/featureFlags';
import { AskFreyaHeader } from '../../organisms/askFreya/AskFreyaHeader';
import WelcomeScreen from '../../organisms/askFreya/WelcomeScreen';
import ChatInput from '../../molecules/askFreya/ChatInput';
import ChatInterface from '../../organisms/askFreya/ChatInterface';
import { AskFreyaProvider, useAskFreya } from './AskFreyaContext';
import { LayoutSidebar } from '../../organisms/sidebar/LayoutSidebar';
import { LandingTopWidget } from '../../organisms/landing';

const AskFreyaContent: React.FC = () => {
  const { messages } = useAskFreya();
  const hasMessages = messages.length > 0;
  const navigate = useNavigate();

  useEffect(() => {
    if (!featureFlags?.SHOW_ASK_FREYA) {
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className='flex flex-col h-full bg-white overflow-hidden relative'>
      <AskFreyaHeader />

      {hasMessages ? <ChatInterface /> : <WelcomeScreen />}

      <div className='px-24 pb-36 w-full max-w-4xl mx-auto'>
        <ChatInput />
      </div>
    </div>
  );
};

export const AskFreyaPage: React.FC = () => (
  <AskFreyaProvider>
    <LandingTopWidget />
    <LayoutSidebar>
      <AskFreyaContent />
    </LayoutSidebar>
  </AskFreyaProvider>
);

export default AskFreyaPage;
